// client/src/components/leagues/StandingsHelpModal.js
import React from 'react'
import { MINIMUM_MATCHES_FOR_ELIGIBILITY } from '../../utils/pointsCalculation'

/**
 * Modal explaining how the points-based standings system works
 * @param {Object} props
 * @param {boolean} props.show - Whether to show the modal
 * @param {Function} props.onClose - Callback when modal is closed
 * @param {string} props.matchFormat - Match format of the league ('TRADITIONAL' or 'PRO_SET_8')
 */
export default function StandingsHelpModal({
  show,
  onClose,
  matchFormat = 'TRADITIONAL',
  minimumMatchesForEligibility = MINIMUM_MATCHES_FOR_ELIGIBILITY,
}) {
  const isProSet = matchFormat === 'PRO_SET_8'
  if (!show) return null

  return (
    <>
      {/* Backdrop */}
      <div
        className="modal-backdrop fade show"
        onClick={onClose}
        style={{ zIndex: 1040 }}
      ></div>

      {/* Modal */}
      <div
        className="modal fade show"
        style={{ display: 'block', zIndex: 1050 }}
        tabIndex="-1"
        role="dialog"
        aria-labelledby="standingsHelpModalLabel"
        aria-modal="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="standingsHelpModalLabel">
                🏆 How Standings Work
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <h6 className="fw-bold">Points Per Match:</h6>
              {isProSet ? (
                <ul className="mb-3">
                  <li>
                    <strong>Win:</strong> 1 point
                  </li>
                  <li>
                    <strong>Lose:</strong> 0 points
                  </li>
                </ul>
              ) : (
                <ul className="mb-3">
                  <li>
                    <strong>Win in 2 Sets:</strong> 8 points
                  </li>
                  <li>
                    <strong>Win in 3 Sets:</strong> 6 points
                  </li>
                  <li>
                    <strong>Lose in 3 Sets:</strong> 3 points
                  </li>
                  <li>
                    <strong>Lose in 2 Sets:</strong> 2 points
                  </li>
                </ul>
              )}

              <h6 className="fw-bold mb-2">Tiebreakers (in order):</h6>
              <ol className="mb-3">
                <li>Total Points</li>
                <li>Total Wins</li>
                <li>Fewest Losses</li>
                <li>Set Win %</li>
                <li>Game Win %</li>
              </ol>

              <hr />

              <div className="alert alert-info mb-0" role="alert">
                <strong>🏆 Playoff Eligibility:</strong> You must play at least{' '}
                <strong>{minimumMatchesForEligibility} matches</strong> to be
                eligible for playoffs.
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                onClick={onClose}
              >
                Got it!
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
